import React from "react";

const ChillerTruckFleetTable = ({ title, description, payloadRows, configRows }) => {
  return (
    <section className="container-fluid py-5 overflow-hidden" style={{ background: "#fff" }}>
      <div className="container py-3">

        <div
          className="mb-4"
          data-aos="fade-up"
          data-aos-duration="900"
          data-aos-once="true"
        >
          <h2 className="h2-title mb-3">{title}</h2>
          <p className="ct-fleet-desc">{description}</p>
        </div>

        {/* Payload Tier Table */}
        <div
          className="mb-4"
          data-aos="fade-up"
          data-aos-delay="100"
          data-aos-once="true"
        >
          <h3 className="ct-table-subtitle">Payload Tier Table</h3>
          <div className="table-responsive">
            <table className="ct-spec-table">
              <thead>
                <tr>
                  <th>Payload Tier</th>
                  <th>Operational Use</th>
                  <th>Tail Lift</th>
                  <th>Rental Duration</th>
                </tr>
              </thead>
              <tbody>
                {payloadRows.map((row, i) => (
                  <tr key={i}>
                    <td><strong>{row.tier}</strong></td>
                    <td>{row.use}</td>
                    <td>{row.tailLift}</td>
                    <td>{row.duration}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Load Configuration Table */}
        <div
          data-aos="fade-up"
          data-aos-delay="150"
          data-aos-once="true"
        >
          <h3 className="ct-table-subtitle">Load Configuration</h3>
          <div className="table-responsive">
            <table className="ct-spec-table ct-config-table">
              <tbody>
                {configRows.map((row, i) => (
                  <tr key={i}>
                    <th>{row.spec}</th>
                    <td>{row.detail}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

      </div>
    </section>
  );
};

export default ChillerTruckFleetTable;
